import React, { lazy, Suspense } from 'react';
import { Route, Switch } from 'react-router-dom';
import { ContainerLoader } from '../../components/loader';

import { RouteKeys } from './route-keys';
import AuthenticateRoute from './AuthenticateRoute';

const Home = lazy(() => import('../home'));
const Dashboard = lazy(() => import('../dashboard'));
const Projects = lazy(() => import('../projects'));
const Resources = lazy(() => import('../resources'));
const Plans = lazy(() => import('../plans'));
const HourLogs = lazy(() => import('../hour-logs'));
const ResourceHourLogs = lazy(() => import('../resource-hour-logs'));
const AdminUsers = lazy(() => import('../admin-users'));
const Teams = lazy(() => import('../teams'));
const Leaves = lazy(() => import('../leaves'));
const Reports = lazy(() => import('../reports'));
const ApiRoles = lazy(() => import('../api-roles'));
const ApiPermissions = lazy(() => import('../api-permissions'));
const AccessLogs = lazy(() => import('../access-logs'));
const NotFound = lazy(() => import('../notfound'));
const Auth = lazy(() => import('../auth'));
const Skills = lazy(() => import('../skills'));
const BudgetTypes = lazy(() => import('../budget-types'));
const PlanVsActual = lazy(() => import('../plan-vs-actual'));

class Routes extends React.Component {
  render() {
    return (
      <Suspense fallback={<ContainerLoader height={500} text={'Loading...'} />}>
        <Switch>
          <AuthenticateRoute path={RouteKeys.Dashboard} component={Dashboard} />
          <AuthenticateRoute path={RouteKeys.Projects} component={Projects} />
          <AuthenticateRoute path={RouteKeys.Resources} component={Resources} />
          <AuthenticateRoute path={RouteKeys.Plans} component={Plans} />
          <AuthenticateRoute path={RouteKeys.HourLogs} component={HourLogs} />
          <AuthenticateRoute
            path={RouteKeys.ResourceHourLogs}
            component={ResourceHourLogs}
          />
          <AuthenticateRoute
            path={RouteKeys.AdminUsers}
            component={AdminUsers}
          />
          <AuthenticateRoute path={RouteKeys.Teams} component={Teams} />
          <AuthenticateRoute path={RouteKeys.ApiRoles} component={ApiRoles} />
          <AuthenticateRoute
            path={RouteKeys.ApiPermissions}
            component={ApiPermissions}
          />
          <AuthenticateRoute path={RouteKeys.Skills} component={Skills} />
          <AuthenticateRoute path={RouteKeys.Leaves} component={Leaves} />
          <AuthenticateRoute path={RouteKeys.Reports} component={Reports} />
          <AuthenticateRoute
            path={RouteKeys.BudgetTypes}
            component={BudgetTypes}
          />
          <AuthenticateRoute
            path={RouteKeys.AccessLogs}
            component={AccessLogs}
          />
          <Route path={RouteKeys.Auth} component={Auth} />
          <Route path={RouteKeys.PlanVsActual} component={PlanVsActual} />
          <Route path={RouteKeys.Home} component={Home} />
          <Route component={NotFound} />
        </Switch>
      </Suspense>
    );
  }
}

export default Routes;
